import { createAction, props } from '@ngrx/store';

import { HealthSummary, HealthYearSummary, SomaticCellCountCow } from './../../models/health.model';

export const loadSomaticCellCountAttentions = createAction(
  '[Health] Load somatic cell count attentions',
  props<{ date: string }>(),
);

export const loadSomaticCellCountAttentionsSuccess = createAction(
  '[Health] Load somatic cell count succeeded',
  props<{ somaticCellCountCows: SomaticCellCountCow[] }>(),
);

export const loadHealthSummaryRequest = createAction(
  '[Health] Load health summary',
  props<{ date: string }>(),
);

export const loadHealthSummarySuccess = createAction(
  '[Health] Health summary loaded succesfully',
  props<{ healthSummary: HealthSummary }>(),
);

export const loadHealthYearSummaryRequest = createAction(
  '[Healt] Load health year summary',
  props<{ date: string }>(),
);

export const loadHealthYearSummarySuccess = createAction(
  '[Healt] Load health year summary loaded succesfully',
  props<{ healthYearSummary: HealthYearSummary }>(),
);
